import styled from 'styled-components'

import FAQs from './FAQs'
import GetStarted from './GetStarted'
import GotQuestions from './GotQuestions'
import HeaderContent from './HeaderContent'
import LogoSection from './LogoSection'
import PropertyManagers from './PropertyManagers'
import RentalManagement from './RentalManagement'
import ScrollSection from './ScrollSection'
import Testimonials from './Testimonials'

const OuterWrapper = styled.div``

const Landlords = () => {
  return (
    <OuterWrapper>
      <HeaderContent />
      <ScrollSection />
      <LogoSection />
      <RentalManagement />
      <Testimonials />
      <PropertyManagers />
      <GotQuestions />
      <FAQs />
      <GetStarted />
    </OuterWrapper>
  )
}

export default Landlords
